const API_VERSION = "v1";
const API_HOST = process.env.REACT_APP_API_URL || "https://api.circuitscramble.com";
const BASE_URL = `${API_HOST}/api/${API_VERSION}`;

const SERVICE_NAME = {
  ADMIN: "admin",
  USER: "user",
};

const EndpointsSlug = {
  // admin-auth
  LOGIN_WITH_GOOGLE: `/${SERVICE_NAME.ADMIN}/auth/login`,

  // admin-classic_level
  ADD_CLASSIC_LEVEL: `/${SERVICE_NAME.ADMIN}/classic_level/add`,
  DELETE_CLASSIC_LEVEL: `/${SERVICE_NAME.ADMIN}/classic_level/delete`,

  // admin-public_level
  GET_PUBLIC_LEVELS: `/${SERVICE_NAME.ADMIN}/public_level/get`,
  GET_PENDING_PUBLIC_LEVELS: `/${SERVICE_NAME.ADMIN}/public_level/pending`,
  GET_REJECTED_PUBLIC_LEVELS: `/${SERVICE_NAME.ADMIN}/public_level/rejected`,
  APPROVE_PUBLIC_LEVEL: `/${SERVICE_NAME.ADMIN}/public_level/approve`,
  REJECT_PUBLIC_LEVEL: `/${SERVICE_NAME.ADMIN}/public_level/reject`,

  // admin-users
  GET_ALL_USERS: `/${SERVICE_NAME.ADMIN}/user/all`,
  GET_ALL_CREATORS: `/${SERVICE_NAME.ADMIN}/user/creators`,

  // admin-topup
  GET_ALL_TOPUPS: `/${SERVICE_NAME.ADMIN}/topup`,
  APPROVE_TOPUP: `/${SERVICE_NAME.ADMIN}/topup/approve`,
  REJECT_TOPUP: `/${SERVICE_NAME.ADMIN}/topup/reject`,

  // user-classic_level
  GET_CLASSIC_LEVELS: `/${SERVICE_NAME.USER}/classic_level/get`,
};

export { EndpointsSlug, BASE_URL };
